import {Injectable} from '@angular/core';
import {ModelGroup} from './ModelGroup';
import {RestApiService} from '../services/rest-api.service';

@Injectable()
export class ModelsDataProvider {

  private modelsGroups: ModelGroup[] = [];

  constructor(private restApi: RestApiService) {

  }

  public getModelsGroups(): ModelGroup[] {
      return this.modelsGroups;
  }

  public loadModels() {
    this.restApi.getModels()
      .subscribe(result => {
        this.modelsGroups = result;
        console.log(result);
      });
  }
}
